<template>
  <!-- 年度分析报告表格 -->
  <div class="page analysisReport">
    <div class="pageTable analysisReport_box">
      <div class="hearder_title">
        <p class="headline2" v-if="getZykInformation.zykName.length > 18">{{getZykInformation.zykName}}专业教学资源库基本报告（{{getZykInformation.zykNum}}）</p>
        <p class="headline" v-else>{{getZykInformation.zykName}}专业教学资源库基本报告（{{getZykInformation.zykNum}}）</p>
        <p class="distinguish">
          <!-- <span>主持单位：{{getZykInformation.hostUnit}}<span v-if="getZykInformation.coHostUnit.length != 0">，</span><span v-for="(item,index) in getZykInformation.coHostUnit" :key="index">{{index == getZykInformation.coHostUnit.length-1 && item || (item + '，') }}</span></span> -->
          <span>主持单位：{{getZykInformation.allHostUnit}}</span>
          <span>数据运行时间：{{startYear}}-01-01 至 {{endYear}}-12-31</span>
          <!-- <span>数据截止时间：2022-10-15</span> -->
        </p>
        <div class="lineBox">
          <p></p>
          <p></p>
        </div>
      </div>

      <table border="1" cellspacing="0" cellpadding="0" class="tables" style="border: none;">
        <tr>
          <th class="borderBaise " style="width: 9%;">一级指标</th>
          <th class="borderBaise borderLeft" style="width: 24%;">二级指标</th>
          <th class="borderBaise borderLeft borderRight" style="width: 46;">三级指标</th>
          <th class="borderBaise" colspan="6" style="width: 21%;">统计值</th>
        </tr>

        <tr>
          <td class="borderBaise borderTop " rowspan="4">用户</td>
          <td class="borderBaise borderTop borderLeft " rowspan="4">用户总数</td>
          <td class=" borderTop borderLeft borderRight borderBottom">注册教师用户数</td>
          <td class="borderBaise borderTop borderBottom " colspan="2">{{userTotal.registerTeacherUserCount}}</td>
        </tr>

        <tr>
          <td class="borderTop bordeLeft">注册学生用户数</td>
          <td class="borderBaise borderTop" colspan="2">{{userTotal.registerStudentUserCount}}</td>
        </tr>

        <tr>
          <td class="borderTop bordeLeft">建设院校已实名教师数</td>
          <td class="borderBaise borderTop" colspan="2">{{userTotal.realnameTeacherCount}}</td>
        </tr>

        <tr>
          <td class="borderBottoms borderTop borderRight bordeLeft">建设院校近三年注册并已实名学生数</td>
          <td class="borderBaise borderTop" colspan="2">{{userTotal.realnameStudentCount}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="1">资源</td>
          <td class="borderBaise borderTop borderLeft" rowspan="1">资源总数</td>
          <td class="borderBaise borderLeft borderRight  borderTop">总量</td>
          <td class="borderBaise borderTop" colspan="2">{{userTotal.resourceCount}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="2">课程</td>
          <td class="borderBaise borderLeft borderTop">标准化课程</td>
          <td class="borderBaise borderLeft borderRight borderTop">总量</td>
          <td class="borderBaise borderTop" colspan="2">{{userTotal.standardCourseCount}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">标准化课程课程开课期数</td>
          <td class="borderBaise borderLeft borderRight borderTop">总量</td>
          <td class="borderBaise borderTop " colspan="2">{{userTotal.standardCourseNperCount}}</td>
        </tr>

        <!-- 用户更新 -->
        <tr v-for="(itemobj6,indexObj6) in userUpdateobj.usersOverTheYears" :key="indexObj6+0.5">
          <td class="borderBaise borderTop" :rowspan='userUpdateobj.usersOverTheYears.length + resourceUpdate.renewalRate.length + 1 + userActive1.renewalRate.length + userActive2.renewalRate.length' v-if="itemobj6.oneLevel">{{itemobj6.oneLevel}}</td>
          <td class="borderBaise borderTop borderLeft" :rowspan='userUpdateobj.usersOverTheYears.length' v-if="itemobj6.secondLevel">{{itemobj6.secondLevel}}</td>
          <td v-if="indexObj6 == userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 != userUpdateobj.usersOverTheYears.length-1">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 == userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop" colspan="6">{{itemobj6.num}}</td>
          <td v-if="indexObj6 != userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj6.num}}</td>
        </tr>

        <tr v-for="(itemobj6,indexObj6) in resourceUpdate.renewalRate" :key="indexObj6+0.5">
          <td class="borderBaise borderTop" :rowspan='resourceUpdate.renewalRate.length + 2' v-if="itemobj6.oneLevel">{{itemobj6.oneLevel}}</td>
          <td class="borderBaise borderTop borderLeft" :rowspan='resourceUpdate.renewalRate.length' v-if="itemobj6.secondLevel">{{itemobj6.secondLevel}}</td>
          <td v-if="indexObj6 == resourceUpdate.renewalRate.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 != resourceUpdate.renewalRate.length-1">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 == resourceUpdate.renewalRate.length-1" class="borderBaise borderTop" colspan="6">{{itemobj6.num}}</td>
          <td v-if="indexObj6 != resourceUpdate.renewalRate.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj6.num}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">删除用户数</td>
          <td class="borderBaise borderTop borderLeft borderRight"><span v-if="flag">{{startYear}}年 - {{endYear}}年</span><span v-else>{{endYear}}年</span>删除用户总数</td>
          <td colspan="6" class="borderBaise borderTop">{{userTotal.deleteUserCount}}</td>
        </tr>

        <tr v-for="(itemobj8,indexObj8) in userActive1.renewalRate" :key="indexObj8+0.6">
          <td class="borderBaise borderTop borderLeft" :rowspan='userActive1.renewalRate.length' v-if="itemobj8.secondLevel">{{itemobj8.secondLevel}}</td>
          <td v-if="indexObj8 == userActive1.renewalRate.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj8.yearUpdate}}</td>
          <td v-if="indexObj8 != userActive1.renewalRate.length-1">{{itemobj8.yearUpdate}}</td>
          <td v-if="indexObj8 == userActive1.renewalRate.length-1" class="borderBaise borderTop" colspan="6">{{itemobj8.num}}</td>
          <td v-if="indexObj8 != userActive1.renewalRate.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj8.num}}</td>
        </tr>

        <tr v-for="(itemobj8,indexObj8) in userActive2.renewalRate" :key="indexObj8+0.6">
          <td class="borderBaise borderTop borderLeft" :rowspan='userActive2.renewalRate.length' v-if="itemobj8.secondLevel">{{itemobj8.secondLevel}}</td>
          <td v-if="indexObj8 == userActive2.renewalRate.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj8.yearUpdate}}</td>
          <td v-if="indexObj8 != userActive2.renewalRate.length-1">{{itemobj8.yearUpdate}}</td>
          <td v-if="indexObj8 == userActive2.renewalRate.length-1" class="borderBaise borderTop" colspan="6">{{itemobj8.num}}</td>
          <td v-if="indexObj8 != userActive2.renewalRate.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj8.num}}</td>
        </tr>

        <!-- 资源更新 -->
        <tr v-for="(itemobj6,indexObj6) in resourceUpdate.resourcesYears" :key="indexObj6+0.5">
          <td class="borderBaise borderTop" :rowspan='resourceUpdate.resourcesYears.length + 2 + resourceUpdate1.renewalRate.length' v-if="itemobj6.oneLevel">{{itemobj6.oneLevel}}</td>
          <td class="borderBaise borderTop borderLeft" :rowspan='resourceUpdate.resourcesYears.length' v-if="itemobj6.secondLevel">{{itemobj6.secondLevel}}</td>
          <td v-if="indexObj6 == resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 != resourceUpdate.resourcesYears.length-1">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 == resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop" colspan="6">{{itemobj6.num}}</td>
          <td v-if="indexObj6 != resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj6.num}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">删除资源数</td>
          <td class="borderBaise borderTop borderLeft borderRight"><span v-if="flag">{{startYear}}年 - {{endYear}}年</span><span v-else>{{endYear}}年</span>删除资源总数</td>
          <td class="borderBaise borderTop" colspan="6">{{userTotal.deleteResourceCount}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">修改资源数</td>
          <td class="borderBaise borderTop borderLeft borderRight"><span v-if="flag">{{startYear}}年 - {{endYear}}年</span><span v-else>{{endYear}}年</span>修改资源总数</td>
          <td class="borderBaise borderTop" colspan="6">{{userTotal.updateResourceCount}}</td>
        </tr>

        <tr v-for="(itemobj6,indexObj6) in resourceUpdate1.renewalRate" :key="indexObj6+0.5">
          <td class="borderBaise borderTop" :rowspan='resourceUpdate1.renewalRate.length + 2' v-if="itemobj6.oneLevel">{{itemobj6.oneLevel}}</td>
          <td class="borderBaise borderTop borderLeft" :rowspan='resourceUpdate1.renewalRate.length' v-if="itemobj6.secondLevel">{{itemobj6.secondLevel}}</td>
          <td v-if="indexObj6 == resourceUpdate1.renewalRate.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 != resourceUpdate1.renewalRate.length-1">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 == resourceUpdate1.renewalRate.length-1" class="borderBaise borderTop" colspan="6">{{itemobj6.num}}</td>
          <td v-if="indexObj6 != resourceUpdate1.renewalRate.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj6.num}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getBasicReportUserVoObj: {}, // 一级指标用户
      getStatResourceDataEntityobj: {}, // 素材资源
      recordsnumber: 0, // 无访问记录总数
      citednumber: 0, // 资源被课程引用的占比
      materialsNum: 0, // 素材资源使用总次数
      visitsNum: 0, // 访问总量
      // situationNum: 0, // 论坛情况
      conditionNum: 0, // 作业情况
      examinationNum: 0, // 考试情况
      getResourceApplicationVoobj: { // 1-素材资源应用情况，2-用户访问行为分布,3-论坛情况,4-作业情况,5-考试情况
        obj1: [],
        obj2: [],
        obj3: [],
        obj4: [],
        obj5: [],
      },
      getCourseCountVoObj: {}, // 课程

      getZykInformation: { // 头部基本信息
        allHostUnit: '',
        coHostUnit: [],
        endTime: '',
        hostUnit: '',
        startTime: '',
        status: '',
        zykName: '',
        zykNum: '',
      },
      userTotal: { // 用户总数
        realnameStudentCount: '',
        realnameTeacherCount: '',
        registerStudentUserCount: '',
        registerTeacherUserCount: '',
        resourceCount: '',
        standardCourseCount: '',
        standardCourseNperCount: '',

        deleteUserCount: '',
        deleteResourceCount: '',
        updateResourceCount: ''
      },
      material: { // 获取素材资源,素材资源使用总次数,素材资源应用情况,平均每个资源使用次数
        resourceCount: '',
        textVo: {
          percentage: '',
          sumValue: '',
        },
        textPPTVo: {
          percentage: '',
          sumValue: '',
        },
        animationVo: {
          percentage: '',
          sumValue: '',
        },
        virtualVo: {
          percentage: '',
          sumValue: '',
        },
        audioVo: {
          percentage: '',
          sumValue: '',
        },
        videoVo: {
          percentage: '',
          sumValue: '',
        },
        smallCourseVo: {
          percentage: '',
          sumValue: '',
        },
        otherVo: {
          percentage: '',
          sumValue: '',
        },
        originVo: {
          percentage: '',
          sumValue: '',
        },
        noActiveResourceCountVo: {
          percentage: '',
          sumValue: '',
        },
        courseResourceVo: {
          percentage: '',
          sumValue: '',
        },
        questionVo: {
          percentage: '',
          sumValue: '',
        },
        resourceLogCount: '',
        viewResourceVo: {
          percentage: '',
          sumValue: '',
        },
        commentResourceVo: {
          percentage: '',
          sumValue: '',
        },
        downloadResourceVo: {
          percentage: '',
          sumValue: '',
        },
        collectionResourceVo: {
          percentage: '',
          sumValue: '',
        },
        otherResourceVo: {
          percentage: '',
          sumValue: '',
        },
        averageResourceLogCount: '',
      },
      courses: { // 标准化课程,无访问标准化课程数,标准化课程的选课用户总数,标准化课程课程开课期数
        courseBzNum: '',
        jsCourseBzNum: '',
        courseBzUserNum: '',
        courseTime: '',
      },

      distribution: [], // 用户访问行为分布
      forum: [], // 论坛情况
      conditions: [], // 作业情况
      // situation: [], // 考试情况

      userUpdateobj: { // 用户更新（历年新增用户数，删除用户数）
        usersOverTheYears: [],
        usersDeleted: 0,
      },

      resourceUpdate: { // 获取同比上一年用户新增率（同比上一年资源更新率,历年新增资源数）
        renewalRate: [],
        resourcesYears: [],
      },

      resourceUpdate1: { // 资源更新（同比上一年资源更新率,历年新增资源数）
        renewalRate: [],
        resourcesYears: [],
      },

      userActive1: { // 获取同比上一年用户新增率（同比上一年资源更新率,历年新增资源数）
        renewalRate: [],
      },

      userActive2: { // 资源更新（同比上一年资源更新率,历年新增资源数）
        renewalRate: [],
      },

      resourcesDeleted: 0, // 删除资源数
      startYear: 0,
      endYear: 0,
      flag: null

    };
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      sessionStorage.setItem('lrmv2token', token)
      let zykid = this.$route.query.zykid;
      this.dataChange(zykid)

      this.startYear = this.$route.query.startYear - 0
      this.endYear = this.$route.query.endYear - 0

      if (this.endYear - this.startYear > 0) {
        this.flag = true
      } else {
        this.flag = false
      }
      console.log(this.flag);
    }
    setTimeout(() => {
      this.getZykInformationVo();
      this.getBasicReportUserVo();
      this.usersOverTheYearss();
      this.usersRates();
      this.userActiveHandler1()
      this.userActiveHandler2()

      this.resourcesYearss();
      this.resouceRates()
      // this.usersDeleteds();
      // this.resourcesDeleteds();
    }, 1000)
  },
  methods: {
    // 切换专业
    dataChange(e) {
      this.$axios.post(this.$apiurls.major_switch, e, {
        loading: false,
      }).then((res) => {
        if (res.data) {
          sessionStorage.setItem('zykId', e)
          this.reload();
        }
      });
    },
    reload() {  //切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    },
    // 获取报告基本信息
    getZykInformationVo() {
      this.$axios.post(this.$apiurls.report_yaer_getZykInformationVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.getZykInformation = res.data;
          this.getZykInformation.allHostUnit = res.data.allHostUnit.replaceAll(',', '，');
        }
      });
    },

    getBasicReportUserVo() {
      this.$axios.post(this.$apiurls.getOtherBasicReportUserVo, { endYearStr: this.endYear, startYearStr: this.startYear }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.userTotal.realnameStudentCount = res.data.realnameStudentCount
          this.userTotal.realnameTeacherCount = res.data.realnameTeacherCount
          this.userTotal.registerStudentUserCount = res.data.registerStudentUserCount
          this.userTotal.registerTeacherUserCount = res.data.registerTeacherUserCount
          this.userTotal.resourceCount = res.data.resourceCount
          this.userTotal.standardCourseCount = res.data.standardCourseCount
          this.userTotal.standardCourseNperCount = res.data.standardCourseNperCount
          this.userTotal.deleteUserCount = res.data.deleteUserCount
          this.userTotal.deleteResourceCount = res.data.deleteResourceCount
          this.userTotal.updateResourceCount = res.data.updateResourceCount
        }
      });
    },

    // 获取用户更新历年新增用户数
    usersOverTheYearss() {
      this.$axios.post(this.$apiurls.getOtherBasicReportResourceOrUserUpdateVo, { endYearStr: this.endYear, startYearStr: this.startYear, type: 1 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].oneLevel = '用户更新';
              res.data[i].secondLevel = '历年新增用户数';
            } else {
              res.data[i].oneLevel = '';
              res.data[i].secondLevel = '';
            }
          }
          this.userUpdateobj.usersOverTheYears = res.data;
        }
      });
    },


    // 获取同比上一年用户新增率
    usersRates() {
      this.$axios.post(this.$apiurls.getOtherBasicReportResourceOrUserUpdateVo, { endYearStr: this.endYear, startYearStr: this.startYear, type: 3 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].secondLevel = '同比上一年用户新增率';
            } else {
              res.data[i].secondLevel = '';
            }
          }
          this.resourceUpdate.renewalRate = res.data
        }
      });
    },


    // 获取资源更新历年新增资源数
    resourcesYearss() {
      this.$axios.post(this.$apiurls.getOtherBasicReportResourceOrUserUpdateVo, { endYearStr: this.endYear, startYearStr: this.startYear, type: 2 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].oneLevel = '资源更新';
              res.data[i].secondLevel = '历年新增资源数';
            } else {
              res.data[i].oneLevel = '';
              res.data[i].secondLevel = '';
            }
          }
          this.resourceUpdate.resourcesYears = res.data;
        }
      });
    },

    // 同比上一年资源新增率
    resouceRates() {
      this.$axios.post(this.$apiurls.getOtherBasicReportResourceOrUserUpdateVo, { endYearStr: this.endYear, startYearStr: this.startYear, type: 4 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].secondLevel = '同比上一年资源新增率';
            } else {
              res.data[i].secondLevel = '';
            }
          }
          this.resourceUpdate1.renewalRate = res.data
        }
      });
    },


    // 已实名用户活跃情况
    userActiveHandler1() {
      this.$axios.post(this.$apiurls.getOtherBasicReportResourceOrUserUpdateVo, { endYearStr: this.endYear, startYearStr: this.startYear, type: 5 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].secondLevel = '已实名用户活跃数';
            } else {
              res.data[i].secondLevel = '';
            }
          }
          this.userActive1.renewalRate = res.data
        }
      });
    },

    userActiveHandler2() {
      this.$axios.post(this.$apiurls.getOtherBasicReportResourceOrUserUpdateVo, { endYearStr: this.endYear, startYearStr: this.startYear, type: 6 }, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].secondLevel = '已实名用户活跃情况';
            } else {
              res.data[i].secondLevel = '';
            }
          }
          this.userActive2.renewalRate = res.data
        }
      });
    },



  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

.analysisReport_box {
  width: 95% !important;
  margin: 0px auto;
  height: 2647px !important;
}

.page {
  background: #fff;
}
.pageTable {
  width: 75%;
  height: auto;
  margin: 40px auto 50px;
}
.hearder_title {
  text-align: center;
  font-weight: 700;
  font-size: 15px;
}

.headline {
  font-size: 39px;
  font-weight: bold;
  /* color: #1d244e; */
  color: #000;
  line-height: 150px;
  margin-top: 41px;
}

.headline2 {
  font-size: 35px;
  font-weight: bold;
  /* color: #1d244e; */
  color: #000;
  line-height: 150px;
  margin-top: 41px;
}

.distinguish {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  /* color: #707f9d; */
  color: #000;
  font-size: 17px;
  font-weight: 400;
  font-size: 30px;
}

.lineBox {
  margin-bottom: 40px;
}
.lineBox p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  padding: 0px;
  margin: 0px;
  margin-top: 8px;
}
.lineBox p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.tables {
  width: 100%;
  text-align: center;
  border-color: rgba(112, 127, 157, 0.4);
}

.tables tr {
  height: 67px;
  /* color: #566178; */
  color: #000;
  font-size: 30px;
  border-color: rgba(112, 127, 157, 0.4);
}

.tables tr:first-child {
  background: rgba(204, 204, 204, 0.403);
}

.el-backtop.backtops {
  background: #66adff;
}

.el-backtop,
.el-calendar-table td.is-today {
  color: #fff;
}

.borderBaise {
  border: 2px solid #b6b6b6;
}

.borderTop {
  border-top-width: 1px;
}

.borderBottom {
  border-bottom-width: 1px;
}
.borderBottoms {
  border-bottom-width: 2px;
}
.borderLeft {
  border-left-width: 1px;
}

.borderRight {
  border-right-width: 1px;
}
</style>
